import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useAuthentication } from '../../../Idp/useAuthentication';
import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ConsumerBackerResponse } from './backer.types';

const useGetBackerConsumerBacker = () => {
  const BackerApi = useBackerApi();

  const getBacker = useCallback(async () => {
    const { data } = await BackerApi.get<ConsumerBackerResponse>('/consumer/backer');
    return data;
  }, [BackerApi]);

  return getBacker;
};

const useShowConsumerBacker = <T = ConsumerBackerResponse>({
  select,
}: { select?: (data: ConsumerBackerResponse) => T } = {}) => {
  const { isAuthenticated } = useAuthentication();
  const getConsumerBacker = useGetBackerConsumerBacker();

  return useQuery({
    queryKey: backerKeys.consumer.backer.detail,
    queryFn: getConsumerBacker,
    select,
    enabled: isAuthenticated,
  });
};

// Selects if the backer has student fees access
const useBackerHasStudentFeesAccess = () => {
  const {
    data: hasStudentFeesAccess,
    isLoading,
    isInitialLoading,
    refetch,
  } = useShowConsumerBacker({
    select: useCallback((data: ConsumerBackerResponse) => data.backer.student_fees_access, []),
  });

  return { hasStudentFeesAccess, isLoading, isInitialLoading, refetch };
};

export { useBackerHasStudentFeesAccess, useShowConsumerBacker };
